export const config =
  import.meta.env.FLEET_FORMS_ENV === "production"
    ? // production
      {
        version: "yandex",
        passportURL: "https://passport.yandex.com",
      }
    : // testing
      {
        version: "yandex",
        passportURL: "https://passport-test.yandex.com",
      };
